import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const Search: FC<Props> = ({ fill, ...otherProps }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...otherProps}
     aria-label="search icon">
      {/* <title>search icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.739 2.5C17.109 2.5 21.477 6.868 21.477 12.238C21.477 14.7715 20.5047 17.0823 18.9136 18.8165L22.0444 21.9407C22.3374 22.2337 22.3384 22.7077 22.0454 23.0007C21.8994 23.1487 21.7064 23.2217 21.5144 23.2217C21.3234 23.2217 21.1314 23.1487 20.9844 23.0027L17.8159 19.843C16.1491 21.1778 14.0357 21.977 11.739 21.977C6.369 21.977 2 17.608 2 12.238C2 6.868 6.369 2.5 11.739 2.5ZM11.739 4C7.196 4 3.5 7.695 3.5 12.238C3.5 16.781 7.196 20.477 11.739 20.477C16.281 20.477 19.977 16.781 19.977 12.238C19.977 7.695 16.281 4 11.739 4Z"
        fill={fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default Search;
